import { render, staticRenderFns } from "./createImprovementModal.vue?vue&type=template&id=44f33614&"
import script from "./createImprovementModal.vue?vue&type=script&lang=js&"
export * from "./createImprovementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f33614')) {
      api.createRecord('44f33614', component.options)
    } else {
      api.reload('44f33614', component.options)
    }
    module.hot.accept("./createImprovementModal.vue?vue&type=template&id=44f33614&", function () {
      api.rerender('44f33614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledgeimprovement/components/createImprovementModal.vue"
export default component.exports